export default __webpack_public_path__ + "static/media/twitter-brands.2e2623c4.svg";